import React from "react";
import "./FullscreenMenu.scss";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import FullscreenHeaderLink from "./FullscreenHeaderLink/FullscreenHeaderLink";

export default function FullscreenMenu(props) {
	const { header, prismicCtx, setMenuOpen } = props;

	return (
		<header data-aos="slide-down" className="fullscreenMenu__wrapper">
			<nav className="fullscreenMenu__container">
				{header.data.body.map((slice, index) => (
					<React.Fragment key={index}>
						{slice.slice_type === "header_linkur" && (
							<FullscreenHeaderLink
								headerLink={slice.primary}
								items={slice.items}
								prismicCtx={prismicCtx}
								setMenuOpen={setMenuOpen}
							/>
						)}
					</React.Fragment>
				))}
				{header.data.vinstri_linkar.map((link, index) => (
					<FullscreenHeaderLink
						key={index}
						headerLink={link}
						prismicCtx={prismicCtx}
					/>
				))}

				<div style={{ display: "flex", justifyContent: "center" }}>
					<Link
						to={"/search"}
						className="fullscreenMenu__searchWrapper"
					>
						<img
							src="/images/search_white.png"
							className="fullscreenMenu__search"
							alt="Leita"
						/>
					</Link>
				</div>
			</nav>
		</header>
	);
}
